import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { assignValueById } from 'utils/Activities/activitiesRemoveDuplicates';
import { useSchool } from '../../SchoolContext';
import { getActivityData } from '../../utils';
import ProfileSection from '../ProfileSection';
import styles from './styles.module.css';
import renderListOfActivitiesTypes from '../utils/renderListOfActivitiesTypes';

export default function IncludedServices({ isFetching }) {
  const { schoolData } = useSchool();
  const activities = getActivityData(schoolData || []) || [];
  const [useAllactivities, setUseAllActivities] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const loadActivities = async () => {
      if (!activities.length) return;

      const servicesProvided = {
        properties: await assignValueById(activities, 7),
        title: 'Servicios Prestados por la institución',
      };
      const refectory = {
        properties: await assignValueById(activities, 8),
        title: 'Comedor',
      };
      const technologies = {
        properties: await assignValueById(activities, 9),
        title: 'Tecnología y plataformas educativas',
      };
      const clothing = {
        properties: await assignValueById(activities, 10),
        title: 'Vestimenta',
      };

      if (servicesProvided.length === 0) {
        setUseAllActivities(null);
      } else {
        setUseAllActivities([
          servicesProvided,
          refectory,
          technologies,
          clothing,
        ]);
      }
    };

    loadActivities();
  }, [activities]);

  useEffect(() => {
    if (!useAllactivities) return;
    setCount(0); // Reset count before recounting
    useAllactivities.forEach((activity) => {
      if (activity.properties.length > 0) {
        setCount((prevCount) => prevCount + 1);
      }
    });
  }, [useAllactivities]);

  if (isFetching) {
    return <>...loading</>;
  }

  if (!count) {
    return <>{' '}</>;
  }

  return (
    <ProfileSection
      title="Servicios Incluidos"
      subtitleLyrics={{
        subtitle: '',
        lyrics: useAllactivities?.description,
      }}
    >
      <div className={styles.sectionsContainer}>
        {renderListOfActivitiesTypes(useAllactivities)}
      </div>
    </ProfileSection>
  );
}

IncludedServices.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};
